import Vue from 'vue'

import Writings from "@/views/Writings"
import Projects from "@/views/Projects"
import Contact from "@/views/Contact"
import Whoami from "@/views/Whoami"
import Gists from "@/views/Gists"

// router
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// routes
const router = new VueRouter({
  routes: [
    {
      component: Projects,
      path: '/projects',
      name: 'projects',
    },
    {
      component: Whoami,
      name: 'whoami',
      path: '/',
    },
    {
      component: Writings,
      name: 'writings',
      path: '/posts',
    },
    {
      component: Contact,
      name: 'contact',
      path: '/me',
    },
    {
      component: Gists,
      name: 'gists',
      path: '/gists',
    },
    {
      path: '/*',
      redirect: '/'
    }
  ]
})

export default router
